import Vue from 'vue';
import store from '../store/store';
import { Parser } from 'json2csv';
import { saveAs } from 'file-saver';
import moment from 'moment-timezone';
import { SUPPORTED_CRYPTO_CURRENCIES } from '../constants';

import CryptoJS from 'crypto-js';

Vue.mixin({
  methods: {
    formatToLocalTime(date) {
      let localTime = moment(date).local().format('HH:mm:ss');
      return localTime;
    },
    formatToLocalDate(date) {
      let localDate = moment(date).local().format('MMM DD YYYY');
      return localDate;
    },
    formatToUTCDate(date) {
      let formattedDate = moment(date).utc().format('MMM DD YYYY');
      return formattedDate;
    },
    formatToUTCTime(date) {
      let formattedTime = moment(date).utc().format('HH:mm:ss');
      return formattedTime;
    },
    formatDate(date, format = 'YYYY-MM-DD') {
      return moment(date).format(format);
    },
    getNextDay(date) {
      return this.formatDate(moment(date, 'YYYY-MM-DD').add(1, 'd'));
    },

    capitalizeWord(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    downloadJsonAsCsv: function (
      opts,
      jsonTransactions,
      saveAsFilename = 'transactions-triplea.csv'
    ) {
      /**
       * Expects `opts` to contain fields (label, value, default):
       * [
       *   {
            label: 'Status', // Optional, column will be labeled 'path.to.something' if not defined)
            value: 'status',
            default: 'NULL'
          },
       * ]
       */

      try {
        const parser = new Parser(opts);
        const csv = parser.parse(jsonTransactions);
        console.log(typeof csv, ' _____ ', csv);

        let blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, saveAsFilename);
      } catch (err) {
        console.warn(err);
      }
    },
    isLoggedIn() {
      return store.state.activeUser;
    },
    filterTx(txData) {
      if (!txData || txData.length === 0) {
        return [];
      }
      return txData.filter(function (tx) {
        return tx.debit !== 1;
      });
    },

    copyToClipboard(value) {
      /**
       * Set text in clipboard.
       */
      let tmp_link = document.createElement('input');
      document.body.appendChild(tmp_link);
      tmp_link.setAttribute('id', 'tmp_link');
      document.getElementById('tmp_link').value = value;
      tmp_link.select();
      document.execCommand('copy');
      document.body.removeChild(tmp_link);
    },

    numberWithCommas(n, fractionDigits = 2) {
      try {
        n = n.toString().replace(/,/g, '');
        let parts = parseFloat(n).toFixed(fractionDigits).toString().split('.');
        return (
          parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          (parts[1] ? '.' + parts[1] : '.00')
        );
      } catch (e) {
        return n;
      }
    },
    numberWithCommasNoFractionDigits(n, fractionDigits = 0) {
      try {
        n = n.toString().replace(/,/g, '');
        let parts = parseFloat(n).toFixed(fractionDigits).toString().split('.');
        return (
          parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          (parts[1] ? '.' + parts[1] : '')
        );
      } catch (e) {
        return n;
      }
    },
    formatCryptoPrice(value) {
      return (value / 1).toFixed(8);
    },
    formatFiatPrice(value) {
      //return (value/1).toFixed(2);
      try {
        return this.numberWithCommas(value);
      } catch (e) {
        return value;
      }
    },
    formatFiatPriceNoDigits(value) {
      //return (value/1).toFixed(2);
      try {
        return this.numberWithCommasNoFractionDigits(value);
      } catch (e) {
        return value;
      }
    },
    b64DecodeUnicode(str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.

      return decodeURIComponent(
        atob(str)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
    },
    b64EncodeUnicode(str) {
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into btoa.
      return btoa(
        encodeURIComponent(str).replace(
          /%([0-9A-F]{2})/g,
          function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
          }
        )
      );
    },
    ping_pageloaded(apiDomain) {
      this.$axios.$get(`${apiDomain}/ping_pageloaded`).then(
        (result) => {
          //console.log("Ping to API: ", result);
          return result;
        },
        (error) => {
          console.warn(error);
        }
      );
    },
    // addDays(myDate, days)
    // {
    //   let date = new Date(myDate.valueOf());
    //   date.setDate(date.getDate() + days);
    //   return date;
    // },
    getDates(startDate, stopDate) {
      let dateArray = [];
      let currentDate = startDate;

      while (currentDate <= stopDate) {
        let newDate = new Date(currentDate);
        dateArray.push(newDate.toISOString().split('T')[0]);
        currentDate = currentDate + 24 * 60 * 60 * 1000;
      }
      return dateArray;
    },
    getDateShort(timestamp) {
      // Returns YYYY-MM-DD.
      if (timestamp && !isNaN(timestamp)) {
        return new Date(timestamp * 1000)
          .toISOString()
          .replace('T', ' ')
          .split('.')[0];
      } else {
        return '';
      }
    },
    getMachineName(name) {
      return name.toLowerCase().replace(/[^a-z-]/g, '');
    },
    debounce(fn, delay) {
      var timeoutID = null;
      return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function () {
          fn.apply(that, args);
        }, delay);
      };
    },
    //password between 8 to 20 characters which contain at least one numeric digit,
    // one uppercase and one lowercase letter
    checkPassword(value) {
      let passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      if (value.match(passw)) {
        return true;
      } else {
        return false;
      }
    },

    //check if current logged in user can see the manage user's page or not (or is the user an admin)
    isUserAnAdmin(currentUser) {
      let isAdmin = false;

      if (
        currentUser.partners &&
        Object.keys(currentUser.partners).length > 0
      ) {
        isAdmin = true;
      }

      for (let merchant of Object.values(currentUser.merchants)) {
        if (
          merchant.group &&
          merchant.group.permissions &&
          ((merchant.group.permissions.entity_admins &&
            merchant.group.permissions.entity_admins.includes('W')) ||
            (merchant.group.permissions['2fa_settings'] &&
              merchant.group.permissions['2fa_settings'].includes('W')))
        ) {
          isAdmin = true;
        }
      }
      return isAdmin;
    },

    //to check which part of the dashboard the current logged in user can see or execute.
    isAllowed(currentUser, merchantId, permission, privilege) {
      let isAllowed = false;
      if (!currentUser) {
        return isAllowed;
      }
      if (currentUser.partners) {
        for (const partnerId of Object.keys(currentUser.partners)) {
          if (
            currentUser.partners &&
            currentUser.partners[partnerId].merchants
          ) {
            const merchantIds = currentUser.partners[partnerId].merchants.map(
              (merchant) => merchant.id
            );
            //if the merchant is under partner, they are automatically deemed as an admin.
            if (merchantIds.includes(merchantId)) {
              isAllowed = true;
              return isAllowed;
            }
          }
        }
      }

      if (currentUser.merchants && currentUser.merchants[merchantId]) {
        const merchant = currentUser.merchants[merchantId];
        if (
          merchant &&
          merchant.group &&
          merchant.group.permissions &&
          merchant.group.permissions[permission] &&
          merchant.group.permissions[permission].includes(privilege)
        ) {
          isAllowed = true;
        }
      }
      return isAllowed;
    },

    //to filter which merchant the user can and cannot see (if the user has 'none' permission -> which is determined by empty object in group property in currentActiveEntityAdminGetter
    hasGroupPermissionToMerchants(currentUser) {
      //check from currentActiveEntityAdminGetter, the merchants property
      let extractedMerchants =
        currentUser && Object.values(currentUser.merchants);
      let merchantsOnly = extractedMerchants.filter(
        (item) => item.group && Object.keys(item.group).length > 0
      );

      //check from currentActiveEntityAdminGetter , the merchants property under partner
      let extractedMerchantsFromPartners =
        currentUser &&
        currentUser.partners &&
        Object.values(currentUser.partners);

      let merchantsUnderPartners = [];
      for (let item of extractedMerchantsFromPartners) {
        for (let merchant of item.merchants) {
          merchantsUnderPartners.push(merchant);
        }
      }
      let hasPermissionToTheseMerchants = merchantsOnly.concat(
        merchantsUnderPartners
      );
      return hasPermissionToTheseMerchants;
    },

    //check if the selectedAccount is local currency account (and not a test account or custody account)
    isLocalCurrencyAccount(activeAccount) {
      let isLocalCurrency = false;
      if (
        activeAccount &&
        activeAccount.settlementType === 'localcurrency' &&
        !activeAccount.apiId.includes('_t')
      ) {
        isLocalCurrency = true;
        return isLocalCurrency;
      } else {
        return isLocalCurrency;
      }
    },
    // check if the inserted payer name are valid characters
    validatePayerName(name) {
      // true means there is an invalid character.
      return /[^(a-zA-Z).,‘-\s\u00C0-\u1FFF\u2800-\uFFFD]+|(--)+|^[.,‘-]|[.,’-]$/g.test(
        name
      );
    },
    is2faEnabled(merchant, functionality) {
      return merchant.two_factor_auth[functionality];
    },

    replaceReservedChars(str) {
      // some symbols are Reserved Characters in a query, ex : + is a regular space
      // this function transforms symbols into their encoding
      // https://www.tutorialspoint.com/html/html_url_encoding.htm
      let res = str.replace('+', '%2b');
      return res;
    },

    isEmail(str) {
      // source : https://www.w3.org/TR/2012/WD-html-markup-20121025/input.email.html#form.data.emailaddress_xref2
      const emailRegex =
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return emailRegex.test(str);
    },

    /**
     * overwrites the util function formatCryptoPrice to take into account special
     * cases like USDT, USDC etc
     * @param {*} amount
     * @param {*} currency
     */
    formatCryptoAmount(amount, currency) {
      if (this.isCurrencyFiatFormat(currency)) {
        return this.formatFiatPrice(amount);
      } else {
        return this.formatCryptoPrice(amount);
      }
    },

    /**
     * Formats to exchange rate Value, with decimals (default is 4)
     * @param {number} amt
     */
    formatExchangeRateValue(amt, decimal = 4) {
      try {
        let formattedRate = Number(amt).toFixed(decimal);

        // if there are tralling zeros, remove it
        formattedRate = formattedRate.replace(/\.?0+$/, '');
        return Number(formattedRate);
      } catch (e) {
        return amt;
      }
    },

    /**
     * Checks wether the input currency is a crypto currency
     * @param currency
     */
    isCryptoCurrency(currency) {
      return SUPPORTED_CRYPTO_CURRENCIES.indexOf(currency) >= 0;
    },

    /**
     * Checks wether the input currency is similar to a fiat currency
     * ex: USDT, USDC, XSGD
     * @param currency
     */
    isCurrencyFiatFormat(currency) {
      return (
        currency.toUpperCase() === 'USDC' ||
        currency.toUpperCase() === 'USDT' ||
        currency.toUpperCase() === 'USDT_TRC20' ||
        currency.toUpperCase() === 'USDC_TRC20' ||
        currency.toUpperCase() === 'XSGD' ||
        currency.toUpperCase() === 'USDT_POLY' ||
        currency.toUpperCase() === 'USDC_POLY' ||
        currency.toUpperCase() === 'USDT_SOL' ||
        currency.toUpperCase() === 'USDC_SOL' ||
        currency.toUpperCase() === 'PYUSD'
      );
    },

    /**
     * Simple formatting function to return 'currency amount', or '-' if amount is 0
     * @param {*} amt
     * @param {*} currency
     */
    formatAmount(amt, currency) {
      if (amt === '0.00' || amt === '0.00000000' || !amt || !currency) {
        // to define wether to print the same if amount lower than 0
        return '-';
      }
      return `${currency} ${amt}`;
    },

    /**
     * Returns the date with the timezone.
     * @param {Date} date
     * @returns
     */
    getDateWithTimezone(date) {
      return moment(date).format();
    },
    standardizeQueryString(obj, trimString = false) {
      const newObj = {};
      Object.keys(obj).forEach((key) => {
        switch (typeof obj[key]) {
          case 'string':
            if (obj[key]) {
              if (trimString) {
                newObj[key] = obj[key].trim();
              } else {
                newObj[key] = obj[key];
              }
            }
            break;
          case 'number':
            newObj[key] = obj[key];
            break;
          default:
            if (obj[key]) {
              newObj[key] = obj[key];
            }
        }
      });

      return newObj;
    },

    toTransferTypeLabel(srcCurrencyType, destCurrencyType) {
      let lbl = srcCurrencyType === 'fiat_money' ? 'Fiat' : 'Crypto';
      lbl += ` to `;
      lbl += destCurrencyType === 'fiat_money' ? 'Fiat' : 'Crypto';
      return lbl;
    },
    toTransferServiceLabel(type) {
      switch (type) {
        case 'bank_account':
          return 'Bank transfer';
        case 'digital_wallet':
          return 'E-wallet';
        case 'cash_pickup':
          return 'Cash pickup';
      }
    },
    // for merchant bank settlements
    formatBankReference(date) {
      const payoutDate = moment(date).utc();
      return 'LC' + payoutDate.format('DDMMYYYYHHmmssSSS');
    },

    // encrypt password
    encryptPassword(password, passphrase) {
      return CryptoJS.AES.encrypt(password, passphrase).toString();
    },

    formatCryptoCurrencyName(cur) {
      const splitted = cur.split('_');
      if (splitted.length > 1) {
        switch (splitted[1].toUpperCase()) {
          case 'TRC20':
            return `${splitted[0]} (Tron)`;
          case 'POLY':
            return `${splitted[0]} (Polygon)`;
          case 'SOL':
            return `${splitted[0]} (Solana)`;
          case 'ARB':
            return `${splitted[0]} (Arbitrum)`;
          default:
            return splitted.join(' ');
        }
      } else {
        switch (cur) {
          case 'None':
            return 'Recipient to choose when claiming funds';
          case 'LNBC':
            return 'LNBC (Bitcoin Lightning)';
          case 'USDT':
            return 'USDT (Ethereum)';
          case 'USDC':
            return 'USDC (Ethereum)';
          default:
            // BTC, ETH and all currency with no specific network selection
            return cur;
        }
      }
    },

    networkNameMapping(network) {
      const networkMap = {
        ERC20: 'Ethereum',
        TRON: 'Tron',
        SOL: 'Solana',
        ARB: 'Arbitrum',
      };
      return networkMap[network] || network;
    },

    // check if given date is more than 90 days
    isPaymentMoreThan90Days(pmt) {
      // Parse the given date string into a Date object
      // rate date is used when in TripleATXPopUp component, as the data we get from that component does not have created_at
      const givenDate = pmt.created_at
        ? new Date(pmt.created_at)
        : new Date(pmt.rate_date);

      // Get the current date
      const currentDate = new Date();

      // Calculate the date 90 days ago from today
      const ninetyDaysAgoDate = new Date();
      ninetyDaysAgoDate.setDate(currentDate.getDate() - 90);

      // Compare the given date with the date one year ago
      return givenDate < ninetyDaysAgoDate;
    },

    isWhitelistedForCryptoBatch() {
      const allowedMerchants = [
        
        'mkey-clxzzr5nl0000t0djbumv1j2o', // Triple-A Support PROD
        'mkey-clljizov4051ougishfzv6k3y', // Triple-A Marketing PROD
        // 'mkey-cls42yos00000h9djeiqieylj', // Triple-A dev account dev@triple-a.io PROD
        
        // 'mkey-4x2c5k47hf2v2rqfis02p9fmxu', // payretailers PROD
        'mkey-cluqj0gq60000xtdjfcsy7n64', // Volume Vision Payout USD
        'mkey-cly2qfwon0000y7dj0kil3fhi', // AURORE PTE. LTD. - Payout - USD
        'mkey-cm2dbttx6000001djaqeg669o', // BESTECHNIQUE LIMITED - Payout - USD
        'mkey-cltwwd6n70000lwdjfkl28al4', // BILLIONAIRE PTE. LTD. - Payout - USD
        'mkey-cm1aj2fck0000x5dj9478dcwy', // FUCONNECT PTE. LTD - Payout - USD
        'mkey-clqgale240000cidj49p05ypq', // FUNI. PTE. LTD. - Payout - USD
        'mkey-clwc2p24k000079djhamagwnx', // FUNI. PTE. LTD - Higo - Payout - USD
        'mkey-cltwwtwu10000gvdj043rgbhh', // PATTI PTE. LTD. - Payout - USD
        'mkey-clrepub5k0000hadjdc0u6i6t', // WELIKE PTE.LTD - Payout - USD
      ];
      const isProdEnv =
        !process.env.VUE_APP_LOCAL_ENV &&
        !process.env.VUE_APP_STAGING_ENV &&
        !process.env.VUE_APP_UAT_ENV;
      return (
        !isProdEnv ||
        allowedMerchants.includes(this.$store.getters.activeMerchantKeyGetter)
      );
    },

    // check if the given currency is a stable coin with an amount of zero or less
    isZeroStableCoin(currency, amt) {
      return (currency === 'USDC' || currency === 'USDT') && amt <= 0;
    },
  },
});
